<template>
  <div>
    <v-container>
      <v-layout row>
        <v-flex xs12 md8 offset-md2>
          <v-card flat class="card--flex-toolbar" color="transparent">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <h2 class="white--text">Zapisy</h2>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <iframe
                  src="https://docs.google.com/forms/d/e/1FAIpQLSeto_NGP0gUUI5uB39HlKU-pazBwxL4OXiWREFe2Wo_vqg5GA/viewform?embedded=true"
                  width="700"
                  height="1400"
                  frameborder="0"
                  marginheight="0"
                  marginwidth="0"
                  >Ładuję…</iframe
                >
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.outine-2 {
  border: 2px solid white;
}

.card--flex-toolbar {
  margin-top: -124px;
}

.learn-more-btn {
  text-transform: initial;
  text-decoration: underline;
}
</style>
